module.exports = __webpack_public_path__ + "static/assets/3bfb87273369a7962be885d2536a739c.gif";